import { FC, ReactNode } from "react";
import { cn } from "@racoon/ui";

/** Section caption of the design (Table Bold Caps). */
export const SectionCaption: FC<{ className?: string; children: ReactNode }> = ({
  className,
  children,
}) => (
  <h3 className={cn("text-xs font-bold uppercase leading-4 text-text-body", className)}>
    {children}
  </h3>
);
